import React, { lazy } from 'react';

const Main = lazy(() => import('pages/Main/Main'));
const Feedback = lazy(() => import('pages/Feedback/Feedback'));
const Offer = lazy(() => import('pages/Offer/Offer'));
const Offer2 = lazy(() => import('pages/OfferAndroid/OfferAndroid'));
const FAQ = lazy(() => import('pages/FAQ/FAQ'));
const Policy = lazy(() => import('pages/Policy/Policy'));
const Cookies = lazy(() => import('pages/Cookies/Cookies'));
const User = lazy(() => import('pages/User/User'));
const NotFound = lazy(() => import('pages/NotFound/NotFound'));

export enum PublicPath {
    main = '/',
    user = '/user/:uuid',
    offer = '/offer',
    offer2 = '/oferta-v-prilozhenii',
    faq = '/faq',
    policy = '/privacypolicy',
    cookies = '/cookies',
    set_cookies = '/cookies?scroll=bottom',
    feedback = '/feedback',
    other = '*',
}

export const publicRoutes = [
    {
        path: PublicPath.main,
        page: <Main />,
    },
    {
        path: PublicPath.user,
        page: <User />,
    },
    {
        path: PublicPath.feedback,
        page: <Feedback />,
    },
    {
        path: PublicPath.offer,
        page: <Offer />,
    },
    {
        path: PublicPath.offer2,
        page: <Offer2 />,
    },
    {
        path: PublicPath.faq,
        page: <FAQ />,
    },
    {
        path: PublicPath.policy,
        page: <Policy />,
    },
    {
        path: PublicPath.cookies,
        page: <Cookies />,
    },
    {
        path: PublicPath.set_cookies,
        page: <Cookies />,
    },
    {
        path: PublicPath.other,
        page: <NotFound />,
    },
];
